import { deprecated, createAsyncAction } from 'typesafe-actions';
import { searchKeywordState } from './types';

const { createAction } = deprecated;

export const SET_SEARCH_KEYWORD = 'searchKeyword/SET_SEARCH_KEYWORD' as const;

export const setSearchKeyword = createAction(
  SET_SEARCH_KEYWORD,
  (action) => (searchKeyword: searchKeywordState['searchKeyword']) => {
    localStorage.setItem('aivory_search_keyword', searchKeyword as string);
    return action(searchKeyword);
  }
);
